import { Heading, SvgIconProps, Text, SvgIcon } from '@cinch-labs/design-system'

import styles from './feature-card.module.css'

export interface FeatureCardProps {
  title: string
  body: string
  icon: SvgIconProps['name']
  children?: React.ReactNode
}
interface ComponentMapType {
  [key: string]: JSX.Element
}

const ComponentMap: ComponentMapType = {
  'arrow-right': <SvgIcon name="arrow-right" size={24} />,
  alert: <SvgIcon name="alert" size={24} />,
  card: <SvgIcon name="card" size={24} />,
  electric: <SvgIcon name="electric" size={24} />,
  'vehicle-front': <SvgIcon name="vehicle-front" size={24} />,
  range: <SvgIcon name="range" size={24} />,
} as const

export const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  body,
  icon,
}) => (
  <div className={styles.card} data-testid="feature-card">
    {icon ? ComponentMap[icon] : null}
    <Heading element="h3" className={styles.title}>
      {title}
    </Heading>
    <Text className={styles.body}>{body}</Text>
  </div>
)
